import React, { useContext } from "react";
import { useAuth } from "auth/useAuth";
import log from "loglevel";
import client from "api/WookAxios";
import UserContext from "user/UserContext";
import { AUTH_STATUS } from 'constants/auth';

export const AuthInitializer = () => {
  const { setUser, setAuthStatus } = useContext(UserContext);

  const { syncAuth } = useAuth();

  React.useEffect(() => {
    const initAuth = async () => {
      try {
        const csrf_response = await client.csrf();
        log.debug('INIT_AUTH_CSRF', csrf_response);
        
        const refresh_response = await client.refresh();
        log.debug('INIT_AUTH_REFRESH auth_state=login', refresh_response)
      } catch(e) {
        log.debug('INIT_AUTH_REFRESH auth_state=logout', e?.response);
        setUser(null);
        setAuthStatus(AUTH_STATUS.UNAUTHENTICATED);
        return;
      }
      
      await syncAuth();
    };
    initAuth();
  }, [syncAuth, setUser, setAuthStatus]);
  
  return null;
};
